module.exports = __webpack_public_path__ + "img/noStock.2391ac69.png";